import logo from "../components/img/1.png";

export const BRAND = {
  name: "Mato Systems",
  logo,
  email: "contact@matosystems.com",
  phone: "+359 98 874 8220",
  address: "Burgas, Bulgaria",
};
